import api from './api'

const FacturaVentaService = {}

FacturaVentaService.consultarElectronica = async function(id){
    return api.get('/FacturaVenta/Electronicas/'+id).then(res => res.data);
}

FacturaVentaService.consultarElectronicasCliente = async function(id) {
    return api.get('/FacturaVenta/Electronicas/Cliente/'+id).then(res => res.data);
}

FacturaVentaService.consultarQr = async function(id) {
    return api.get('/FacturaVenta/QR/'+id).then(res => res.data);
}

export default FacturaVentaService